import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(5),
    height: "100%",
    borderRadius: 8,
    "@media (min-width: 1200px)": {
      maxWidth: "none",
    },
  },
  backContainer: {
    color: theme.palette.Primary.background,
    textTransform: "capitalize",
    display: "flex",
    paddingBottom: theme.spacing(5),
    alignItems: "center",
    cursor: "pointer",
  },
  content: {
    margin: "0 auto",
  },
  commonChart: {
    padding: "50px 10px 10px 10px",
    width: "85%",
    background: "white",
    marginBottom: "10px",
  },
  headings: {
    fontWeight: 500,
    marginBottom: "25px",
  },
  commonSuggestion: {
    padding: "50px 10px 10px 10px",
    width: "85%",
    background: "white",
    marginBottom: "10px",
  },
  mainContentText: {
    fontWeight: 500,
    marginBottom: "10px",
    marginTop: "10px",
  },
  tooltip: {
    cursor: "pointer",
    "& .MuiTooltip-tooltip": {
      backgroundColor: ` ${theme.palette.Primary.light} !important`,
      border: "1px solid rgb(10, 9, 10)",
      color: "black",
    },
  },
  subtopicTitle: {
    "& .MuiSvgIcon-root": {
      width: "0.5em",
      // height : '2em'
    },
    padding: "10px",
    display: "flex",
    justifyItems: "center",
  },
  infoIcon: {
    fontSize: "larger",
    color: "black",
    cursor: "pointer",
  },
  suggesionContentText: {
    paddingLeft: "5px",
  },
  overAllSuggesion: {
    display: "flex",
    alignItems: "center",
  },
  suggesionContentTextTopic: {
    paddingLeft: "10px",
  },
  zMain: { width: "min-content", background: "white", minWidth: "85%" },
  zSub: { position: "relative" },
  zTable: { borderCollapse: "collapse", width: "100%" },
  cellStyleWithoutBorder: {
    padding: "8px",
    height: "40px",
    textAlign: "center",
    width: "115px", // Set exact width
    minWidth: "115px", // Ensure it doesn’t shrink below
    maxWidth: "115px", // Prevent it from growing
    boxSizing: "border-box", // Ensures padding and border are included in the 30px width
    overflow: "hidden", // Prevent text overflow
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  cellStyleWithoutBorder2: {
    padding: "8px",
    height: "40px",
    textAlign: "center",
    width: "119px", // Set exact width
    minWidth: "119px", // Ensure it doesn’t shrink below
    maxWidth: "119px", // Prevent it from growing
    boxSizing: "border-box", // Ensures padding and border are included in the 30px width
    overflow: "hidden", // Prevent text overflow
    whiteSpace: "break-spaces",
  },
  cellStyleWithoutBorder3: {
    padding: "8px",
    height: "40px",
    textAlign: "center",
    width: "128px", // Set exact width
    minWidth: "128px", // Ensure it doesn’t shrink below
    maxWidth: "128px", // Prevent it from growing
    boxSizing: "border-box", // Ensures padding and border are included in the 30px width
    overflow: "hidden", // Prevent text overflow
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  zTableHeaderStake: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  zHorizontalLine: {
    width: "55px",
    height: "2px",
    backgroundColor: "grey",
  },
  cellStyle: {
    border: "1px solid #ccc",
    padding: "8px",
    minWidth: "80px",
    height: "40px",
    textAlign: "center",
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
  },
  svgStyle: {
    position: "absolute",
    top: 0,
    left: 0,
    pointerEvents: "none",
    zIndex: 1,
  },
  verticalText: {
    writingMode: "vertical-rl",
    transform: "rotate(180deg)" /* Optional: rotate to have text bottom-up */,
    // whiteSpace: "nowrap",
    textAlign: "center",
    border: "1px solid #ccc",
    padding: "8px",
    height: "40px",
    width: "128px", // Set exact width
    minWidth: "128px", // Ensure it doesn’t shrink below
    maxWidth: "128px", // Prevent it from growing
    boxSizing: "border-box", // Ensures padding and border are included in the 30px width
  },
  cellStyleCase: {
    border: "1px solid #ccc",
    padding: "4px", // Reduce padding to fit the smaller width
    width: "70px", // Set exact width
    minWidth: "70px", // Ensure it doesn’t shrink below
    maxWidth: "70px", // Prevent it from growing
    height: "40px", // Keep your height as-is
    textAlign: "center",
    boxSizing: "border-box", // Ensures padding and border are included in the 30px width
    overflow: "hidden", // Prevent text overflow
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  dispDiv: {
    display: "flex",
    alignItems: "center",
  },
  zigZagCommonSuggestion: {
    padding: "20px 10px 10px 10px",
    background: "white",
    margin: "10px 0px",
  },
  spiderMain: { background: "white" },
  zigConfig: {
    display: "flex",
    alignItems: "flex-start",
  },
  scaleMatrix: {
    display: "flex",
    justifyContent: "flex-end",
  },
}));

export default useStyles;
